
import axios, { AxiosResponse } from 'axios';
import { defineComponent } from 'vue';
import {Payment} from "@/modules";

export default defineComponent({
  data() {
    return {
      payments: [] as Payment[],
      selectedPayment: null as Payment | null,
      showModal: false,
      isLoading: false
    };
  },

  mounted() {
    this.loadFromLocalStorage();
    if (this.payments.length === 0) {
      this.getPayments();
    }
  },
  methods: {
    async getPayments(): Promise<void> {
      this.isLoading = true;
      try {
        if (localStorage.getItem('payments')) {
          this.payments = JSON.parse(localStorage.getItem('payments')!) as Payment[];
        } else {
          const response: AxiosResponse<Payment[]> = await axios.get('https://jsonplaceholder.typicode.com/posts');
          this.payments = response.data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
        this.saveToLocalStorage();
      }
    },
    showPaymentDetails(payment: Payment): void {
      this.selectedPayment = payment;
      this.showModal = true;
    },
    saveToLocalStorage(): void {
      localStorage.setItem('payments', JSON.stringify(this.payments));
    },

    loadFromLocalStorage(): void {
      const payments = localStorage.getItem('payments');
      if (payments) {
        this.payments = JSON.parse(payments) as Payment[];
      }
    },

    closeModal(): void {
      this.selectedPayment = null;
      this.showModal = false;
    },
    calculateAmount(id: number | undefined): string {
      return (id ? id * Math.floor(Math.random() * (100000 - 100 + 1)) + 100 : '') as string;
    },
    truncateText(text: string | undefined, length: number): string | undefined {
      if (text && text.length) {
        if (text.length <= length) {
          return this.capitalizeFirstLetter(text);
        }
        const truncatedText = text.slice(0, length);
        return this.capitalizeFirstLetter(truncatedText);
      }
    },
    capitalizeFirstLetter(text: string): string {
      return text.charAt(0).toUpperCase() + text.slice(1);
    }
  }
});
